
export default {
  data: () => ({

    rawData:  [],
    
    config: null,
    menu: null,
    title: null,
    schedule: null,
    chart: null,
    header: null,
    table: null,
    columns: null,

    canvasForms:  null,
    gY: 0,

  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_ColorStyles() {
      this.gmx_ColorH4Sets()
    },

    draw_Line(selection, x1_, x2_, y1_, y2_, stroke_) {
      selection
      .append('line')
      .attr('x1', x1_).attr('x2', x2_)
      .attr('y1', y1_).attr('y2', y2_)
      .attr('stroke', stroke_)
      .attr('stroke-width', .5)
    },

    draw_Text(selection, id_, x_, y_, tSize_, tColor_, align_, txt_) {
      selection
      .append('text')
      .attr('id', id_)
      .attr('x', x_).attr('y', y_)
      .attr('font-size', tSize_).attr('text-anchor', align_)
      .attr('fill', tColor_)
      .text(txt_)
    },

    draw_Progress(selection, data, col, x, y, color) {
      let tbl = this.table
      let barY = y - this.table.pro.pulsY
      let pro = data[col.code]
      let barLen = (pro/100) * (col.width-10)

      selection
      .append('rect')
      .attr('x', x + .5).attr('y', barY)
      .attr('width', 100).attr('height', 12)
      .attr('fill', '#F4F5F5').attr('opacity', 1)

      selection
      .append('rect')
      .attr('x', x + .5).attr('y', barY)
      .attr('width', barLen).attr('height', 12)
      .attr('fill', color).attr('opacity', 1)

      selection
      .append('text')
      .attr('x', pro > 70 ? col.sx + 5 + barLen - 2 : col.sx + 5 + barLen + 2).attr('y', y+3)
      .attr('font-size', tbl.tSize).attr('text-anchor', pro > 70 ? 'end' : 'start').attr('fill', col.tColor)
      .text(pro+'%')
    }

  }

}